import { getErrorMessage } from "../locales/translationUtils";
import { capitalizeFirstLetter } from "../utils";
import api from "./api";

export interface DistinctDataResponse {
    data: {
        values: DistinctData[]
    },
    messages?: string[] | null
}

export interface DistinctData {
    id: number;
    description: string;
}

/**
 * Dicionário para mapear nomes e campos distintos padrão de entidades da tela
 * de Release.
 */
const entityMap: Record<string, string> = {
    client: "Name",
    destination: "Description",
    wareHouse: "Name",
    freightType: "Description",
    supplier: "Name"
};

export const getDistinctOptions = async (entity: string) => {
    try {
        // Se for clientWithBranches, usar endpoint específico
        if (entity === 'clientWithBranches') {
            const url = '/Client/withBranches';
            const response = await api.get<DistinctDataResponse>(url);
            return response?.data?.data?.values;
        }

        const fieldName: string = entityMap[entity];
        const url: string = `/${capitalizeFirstLetter(entity)}/distinct?campoDistinto=${fieldName}`;

        const response = await api.get<DistinctDataResponse>(url);
        return response?.data?.data?.values;
    } catch (error) {
        console.error(getErrorMessage("fetchDistinctOptionsError", { entity }));
        throw error;
    }
}